export var componentsLocales = {
  removeButtonAriaLabel: 'Удалить токен'
};